import { call, put, takeLatest } from "redux-saga/effects";
import { fetchProfileRequest, getProfileSuccess, getProfileFailure, fetchCRMProfileRequest, getCRMProfileSuccess, getCRMProfileFailure, fetchCountryRequest, getCountrySuccess, getCountryFailure, fetchCityRequest, getCitySuccess, getCityFailure, fetchStateRequest, getStateSuccess, getStateFailure, fetchCurrencyRequest, getCurrencySuccess, getCurrencyFailure, getRopCountrySuccess, getRopCountryFailure, fetchRopCountryRequest, getRopStateSuccess, getRopStateFailure, fetchRopStateRequest, fetchRopCityRequest, getRopCitySuccess, getRopCityFailure } from "../../slice/fetchProfileSlice";
import api from "../../../../config/api";
import { config } from "../../../../config/global";
const data = {
  mode: "no-cors",
  headers: {
    // memberId: sessionStorage.getItem("memberId"),
    "App-Authorization": localStorage.getItem("accesstoken") || "",
    "content-type": "application/json",
    "Access-Control-Allow-Origin": "*"
  },
  loader: true,
  isGenericErr: true
};
const fetchProfileData = async () => {
  const FETCH_PROFILE_API_URL = config?.ROP_FETCH_PROFILE;
  const response = await api.get(FETCH_PROFILE_API_URL, data);
  sessionStorage.setItem("privilegeCard", response.data.privilegeCard === "MEMBER" ? "SILK" : response.data.privilegeCard);
  sessionStorage.setItem("remainingMiles", response?.data?.remainingMiles);
  return response;
};
function* getProfileData() {
  try {
    const response = yield call(fetchProfileData);
    yield put(getProfileSuccess(response.data));
  } catch (error) {
    yield put(getProfileFailure(error.message));
  }
}
const fetchCRMProfileData = async () => {
  const FETCH_CRM_PROFILE_API_URL = config.CRM_FETCH_PROFILE;
  const response = await api.get(FETCH_CRM_PROFILE_API_URL, data);
  return response;
};
function* getCRMProfileData() {
  try {
    const response = yield call(fetchCRMProfileData);
    yield put(getCRMProfileSuccess(response.data));
  } catch (error) {
    yield put(getCRMProfileFailure(error.message));
  }
}
const fetchCountryData = async () => {
  const FETCH_COUNTRIES = config?.COUNTRY_DATA;
  const response = await api?.get(FETCH_COUNTRIES, data);
  return response;
};
function* getCountryData() {
  try {
    const response = yield call(fetchCountryData);
    yield put(getCountrySuccess(response.data));
  } catch (error) {
    yield put(getCountryFailure(error.message));
  }
}
const fetchCityData = async () => {
  const FETCH_CITIES = config.CITY_DATA;
  const response = await api.get(FETCH_CITIES, data);
  return response;
};
function* getCityData() {
  try {
    const response = yield call(fetchCityData);
    yield put(getCitySuccess(response.data));
  } catch (error) {
    yield put(getCityFailure(error.message));
  }
}
const fetchStateData = async () => {
  const FETCH_STATES = config.STATE_DATA;
  const response = await api.get(FETCH_STATES, data);
  return response;
};
function* getStateData() {
  try {
    const response = yield call(fetchStateData);
    yield put(getStateSuccess(response.data));
  } catch (error) {
    yield put(getStateFailure(error.message));
  }
}
const fetchCurrencyData = async () => {
  const FETCH_CURRENCY = config.CURRENCY_DATA;
  const response = await api.get(FETCH_CURRENCY, data);
  return response;
};
function* getCurrencyData() {
  try {
    const response = yield call(fetchCurrencyData);
    yield put(getCurrencySuccess(response.data));
  } catch (error) {
    yield put(getCurrencyFailure(error.message));
  }
}
const fetchCountryRopData = async () => {
  const FETCH_COUNTRIES = config?.ROP_COUNTRY_ROP_DATA;
  const response = await api?.get(FETCH_COUNTRIES, data);
  return response;
};
function* getCountryRopData() {
  try {
    const response = yield call(fetchCountryRopData);
    yield put(getRopCountrySuccess(response.data));
  } catch (error) {
    yield put(getRopCountryFailure(error.message));
  }
}
const fetchRopStateData = async () => {
  const FETCH_STATES = config.ROP_STATE_ROP_DATA;
  const response = await api.get(FETCH_STATES, data);
  return response;
};
function* getRopStateData(action) {
  const countryCode = action.payload;
  try {
    const response = yield call(fetchRopStateData);
    yield put(getRopStateSuccess(response.data));
  } catch (error) {
    yield put(getRopStateFailure(error.message));
  }
}
const fetchRopCityData = async () => {
  const FETCH_STATES = config.ROP_CITY_ROP_CODE;
  const response = await api.get(FETCH_STATES, data);
  return response;
};
function* getRopCityData(action) {
  const countryCode = action.payload;
  try {
    const response = yield call(fetchRopCityData);
    console.log("jellll");
    yield put(getRopCitySuccess(response.data));
  } catch (error) {
    yield put(getRopCityFailure(error.message));
  }
}
export function* watchProfileData() {
  yield takeLatest(fetchProfileRequest.type, getProfileData);
}
export function* watchCRMProfileData() {
  yield takeLatest(fetchCRMProfileRequest.type, getCRMProfileData);
}
export function* watchCountry() {
  yield takeLatest(fetchCountryRequest.type, getCountryData);
}
export function* watchCity() {
  yield takeLatest(fetchCityRequest.type, getCityData);
}
export function* watchState() {
  yield takeLatest(fetchStateRequest.type, getStateData);
}
export function* watchCurrency() {
  yield takeLatest(fetchCurrencyRequest.type, getCurrencyData);
}
export function* watchRopState() {
  yield takeLatest(fetchRopStateRequest.type, getRopStateData);
}
export function* watchRopCity() {
  yield takeLatest(fetchRopCityRequest.type, getRopCityData);
}
export function* watchRopCountry() {
  yield takeLatest(fetchRopCountryRequest.type, getCountryRopData);
}